<template>
    <div class="app-main" id="srm-index">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card mg-b5">
            <div class="el-menu-box">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
                    <el-menu-item
                        v-for="item in menus"
                        :key="item.key"
                        :index="item.key">
                            {{item.name}}({{item.count}})
                    </el-menu-item>
                </el-menu>
            </div>
        </el-card>
        <div class="order-wrap">
            <XjOrderTable v-if="activeIndex == 'all'" pageFlag="all"/>
            <XjOrderTable v-if="activeIndex == 'inquiry'" pageFlag="inquiry"/>
            <XjOrderTable v-if="activeIndex == 'inquiryIng'" pageFlag="inquiryIng"/>
            <XjOrderTable v-if="activeIndex == 'tenderOrder'" pageFlag="tenderOrder"/>
            <XjOrderTable v-if="activeIndex == 'awaitAuditOrder'" pageFlag="awaitAuditOrder"/>
            <XjOrderTable v-if="activeIndex == 'endAuditOrder'" pageFlag="endAuditOrder"/>
            <XjOrderTable v-if="activeIndex == 'noticeAward'" pageFlag="noticeAward"/>
        </div>
    </div>
</template>
<script>
import XjOrderTable from './XjOrderTable'
import { getStatistics,getStatisticsGys } from '@/api/srm/inquiry.js'
export default {
    components:{
        XjOrderTable
    },
    data(){
        return {
            activeIndex:'all',
            menus:[
                {key:'all',name:'全部',count:0},
                {key:'inquiry',name:'待询价',count:0},
                {key:'inquiryIng',name:'询价中',count:0},
                {key:'tenderOrder',name:'待定标',count:0},
                {key:'awaitAuditOrder',name:'定标审批中',count:0},
                {key:'endAuditOrder',name:'定标已审核',count:0},
                {key:'noticeAward',name:'已发布中标通知',count:0},
            ],
        }
    },
    created(){
        if(this.checkRole('cgy_role') || this.checkRole('leader') || this.checkRole('pw')){
            this.getStatisticsCgy()
        }
    },
    methods:{
        async getStatisticsCgy() {
            let _this = this;
            const { data: res } = await getStatistics({})
            if (res.code == 0) {
                let newMenus = [...this.menus];
                let sta = res.data.statistics || [];
                sta.forEach((item)=>{
                    if(item.code == 0){
                        newMenus[0].count = item.count;
                    }
                    if(item.code == 1){
                        newMenus[1].count = item.count;
                    }
                    if(item.code == 2){
                        newMenus[2].count = item.count;
                    }
                    if(item.code == 3){
                        newMenus[3].count = item.count;
                    }
                    if(item.code == 4){
                        newMenus[4].count = item.count;
                    }
                    if(item.code == 6){
                        newMenus[5].count = item.count;
                    }
                    if(item.code == 7){
                        newMenus[6].count = item.count;
                    }
                })
                this.menus = newMenus;
            }
        },


        handleSelect(key){
            this.activeIndex = key;
        },
    }
}
</script>
<style lang="scss">
    #srm-index{
        .el-menu-box{
            width:100%;
        }
    }
</style>


